import type { Context, Plugin } from '@segment/analytics-next'

import { fetchUtmCampaign, toSegmentCampaign } from '@/utils/utmCampaignUtil'

/**
 * Attaches the UTM parameters stored from a free trial link to the event as
 * Segment's `context.campaign`.
 * @param ctx The Segment event context
 * @returns The same context, enriched when UTM parameters are stored
 */
export const addCampaignContext = (ctx: Context): Context => {
  const utmCampaign = fetchUtmCampaign()
  const pageCampaign = ctx.event.context?.campaign

  // Segment's own enrichment fills `campaign` from the current URL first. A page
  // opened with its own UTMs is the more recent touch, so it is left alone; an
  // empty object only means the URL had a query string without any UTMs.
  if (utmCampaign && !(pageCampaign && Object.keys(pageCampaign).length > 0)) {
    ctx.updateEvent('context.campaign', toSegmentCampaign(utmCampaign))
  }

  return ctx
}

export const campaignContextPlugin: Plugin = {
  name: 'UTM Campaign Context',
  type: 'enrichment',
  version: '1.0.0',
  isLoaded: () => true,
  load: () => Promise.resolve(),
  track: addCampaignContext,
  identify: addCampaignContext,
  page: addCampaignContext,
  group: addCampaignContext,
  alias: addCampaignContext,
  screen: addCampaignContext,
}
